import { zetApi } from '@zet/network'

import { IEnrollToTraining } from '../types'

export async function enrollToTraining(data: IEnrollToTraining) {
  const response = await zetApi.post(`/training/register/v2`, data)

  return response
}
